<div nz-row>
  <div nz-col [nzSm]="{ offset: 6, span: 14 }" [nzXs]="{ offset: 0, span: 24 }">
    <h2>Assign to Organization</h2>
  </div>
</div>

<form nz-form [formGroup]="group" (ngSubmit)="onSubmit()">
  <nz-form-item>
    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name"> Name </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24">
      <input nz-input formControlName="name" id="name" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="email"> Email </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24">
      <input nz-input formControlName="email" id="email" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="organization">
      Organization
    </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Organization requiered">
      <nz-select nzAllowClear nzShowSearch formControlName="organization" id="organization">
        <nz-option
          *ngFor="let item of organizations"
          [nzLabel]="item.name"
          [nzValue]="item"
        ></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control [nzSm]="{ offset: 6, span: 14 }" [nzXs]="{ offset: 0, span: 24 }">
      <button nz-button nzType="primary" style="margin: 0 0.5rem 0.5rem 0">Save</button>
    </nz-form-control>
  </nz-form-item>
</form>

<app-spinner *ngIf="loading"></app-spinner>
